/**
 * 警告弹框组件
 */
 
<template>
  <div class="tip" v-if="tag === 'common'">
    <div class="tip__alert">
      <div class="tip__content">{{message}}</div>
      <div class="tip__btns">
        <a class="tip__btn" @click="submitEvent">确定</a>
      </div>
    </div>
  </div>
  <!-- 答对弹框 -->
  <div class="alertshadow" v-else-if="tag === 'answerRight'">
    <div class="alertView">
      <img class="img" :src="images.alert"/>
      <span class="text">{{message}}</span>
    </div>
    <img class="close" :src="images.close" @click="submitEvent"/>
  </div>
</template>

<script>
import {
  IMG_QUESTION_ALERT,
  IMG_QUESTION_CLOSE
} from '../assets'
export default {
  name: "Tip",
  props: {
    tag:{
      type: String,
      default:"common"
    },
    message: {
      type: String,
      required: true
    },
    submitEvent:Function
  },
  data() {
    return {
      images:{
        alert: IMG_QUESTION_ALERT,
        close: IMG_QUESTION_CLOSE
      }
    };
  },
  components: {},
  methods: {
  },
  create() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.tip {
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 300;
  position: fixed;
}

.tip__alert {
  width: 280px;
  background: #fff;
  border-radius: 10px;
  left: 50%;
  top: 50%;
  border: 1px solid #efefef;
  margin: -50px 0 0 -140px;
  z-index: 10000002;
  position: fixed;
  text-align: center;
}

.tip__content {
  padding: 20px;
  border-bottom: solid 1px #efefef;
}

.tip__btns {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
}

.tip__btn {
  color: #08c;
  width: 50%;
  height: 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.alertshadow{
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .alertView{
    width: 300px;
    border-radius: 5px;
    position: relative;
    .img{
      width: 100%;
    }
    .text{
      position: absolute;
      bottom: 12%;
      font-size: 15px;
      color: #333333;
      left: 0;
      width: 100%;
      text-align: center;
    }
  }
  .close{
    width: 40px;
    margin-top: 20px;
    cursor: pointer;
  }
}
</style>
